
import { toast } from "react-toastify";
import { call, put, takeEvery } from "redux-saga/effects";
import ToastElement from "../../../components/toast";
import {
    getCustomTabError,
    getCustomTabSuccess,
    updateCustomTabError,
    updateCustomTabSuccess,
    getCustomSortedTabError,
    getCustomSortedTabSuccess,
    updateCustomSortedTabError,
    updateCustomSortedTabSuccess,
    getCustomTab,
} from "../actions/custom-tab";
import { GET_CUSTOM_TAB, UPDATE_CUSTOM_TAB, GET_CUSTOM_SORTED_TAB, UPDATE_CUSTOM_SORTED_TAB } from "../types";
import CanteenService from "../../../services/canteen-service";

export function* watchGetCustomTab() {
    yield takeEvery(GET_CUSTOM_TAB, getCustomTabAc);
}

const getCustomTabAsync = async (canteenId) => {
    return CanteenService.getCustomTab(canteenId);
};

function* getCustomTabAc({ payload }) {
    try {
        const response = yield call(getCustomTabAsync, payload.canteenId);
        if (response.data.success) {
            yield put(getCustomTabSuccess(response.data.data));
        } else {
            yield put(getCustomTabError(response.data.message));
            toast.error(
                <ToastElement type="error" message={response.data.message} />,
                { containerId: "default", position: "bottom-right" }
            );
        }
    } catch (error) {
        yield put(getCustomTabError(error.response.data.message));
        toast.error(
            <ToastElement type="error" message={error.response.data.message} />,
            { containerId: "default", position: "bottom-right" }
        );
    }
}

export function* watchUpdateCustomTab() {
    yield takeEvery(UPDATE_CUSTOM_TAB, updateCustomTabAc);
}

const updateCustomTabAsync = async (data) => {
    return CanteenService.updateCustomTab(data);
};

function* updateCustomTabAc({ payload }) {
    try {
        const response = yield call(updateCustomTabAsync, payload.customTabData);
        if (response.data.success) {
            yield put(updateCustomTabSuccess(response.data.data));
            yield put(getCustomTab(payload.customTabData?.canteen_id));
            toast.success(
                <ToastElement type="success" message={response.data.message} />,
                { containerId: "default", position: "bottom-right" }
            );
        } else {
            yield put(updateCustomTabError(response.data.message));
            toast.error(
                <ToastElement type="error" message={response.data.message} />,
                { containerId: "default", position: "bottom-right" }
            );
        }
    } catch (error) {
        yield put(updateCustomTabError(error.response.data.message));
        toast.error(
            <ToastElement type="error" message={error.response.data.message} />,
            { containerId: "default", position: "bottom-right" }
        );
    }
}



export function* watchGetCustomSortedTab() {
    yield takeEvery(GET_CUSTOM_SORTED_TAB, getCustomSortedTabAc);
}

const getCustomSortedTabAsync = async (canteenId) => {
    return CanteenService.getCustomSortedTab(canteenId);
};

function* getCustomSortedTabAc({ payload }) {
    try {
        const response = yield call(getCustomSortedTabAsync, payload.canteenId);
        if (response.data.success) {
            yield put(getCustomSortedTabSuccess(response.data.data));
        } else {
            yield put(getCustomSortedTabError(response.data.message));
            toast.error(
                <ToastElement type="error" message={response.data.message} />,
                { containerId: "default", position: "bottom-right" }
            );
        }
    } catch (error) {
        yield put(getCustomSortedTabError(error.response.data.message));
        toast.error(
            <ToastElement type="error" message={error.response.data.message} />,
            { containerId: "default", position: "bottom-right" }
        );
    }
}

export function* watchUpdateCustomSortedTab() {
    yield takeEvery(UPDATE_CUSTOM_SORTED_TAB, updateCustomSortedTabAc);
}

const updateCustomSortedTabAsync = async (data) => {
    return CanteenService.updateCustomSortedTab(data);
};

function* updateCustomSortedTabAc({ payload }) {
    try {
        const response = yield call(updateCustomSortedTabAsync, payload.customSortedTabData);
        if (response.data.success) {
            yield put(updateCustomSortedTabSuccess(response.data.data));
            payload?.callback?.();
            toast.success(
                <ToastElement type="success" message={response.data.message} />,
                { containerId: "default", position: "bottom-right" }
            );
        } else {
            yield put(updateCustomSortedTabError(response.data.message));
            toast.error(
                <ToastElement type="error" message={response.data.message} />,
                { containerId: "default", position: "bottom-right" }
            );
        }
    } catch (error) {
        yield put(updateCustomSortedTabError(error.response.data.message));
        toast.error(
            <ToastElement type="error" message={error.response.data.message} />,
            { containerId: "default", position: "bottom-right" }
        );
    }
}